import { M } from "../../data/site";

export const LogoMark = ({ className = "h-11" }) => (
  <img src={M("logo_mark_sm.webp")} alt="" aria-hidden="true" className={`w-auto mix-blend-screen ${className}`} style={{ aspectRatio: "280 / 160" }} />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className={compact ? "h-9" : "h-10 sm:h-12"} />
    <span className="leading-none">
      <img src={M("logo_name_sm.webp")} alt="HonestChoice AI" className={`w-auto mix-blend-screen ${compact ? "h-5" : "h-5 sm:h-6"}`} style={{ aspectRatio: "540 / 60" }} />
      {!compact && (
        <span className="mt-1.5 hidden font-mono text-[0.58rem] tracking-[0.28em] text-slate-300 sm:block">
          ONE COMPANION. <span className="text-cyan-300">ENDLESS</span> POSSIBILITIES.
        </span>
      )}
    </span>
  </span>
);
